<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { getParamsTemplate } from '@/app/core/services/receipt-templates'
import Editor from '@tinymce/tinymce-vue'

withDefaults(
  defineProps<{
    modelValue: string
    error?: string
  }>(),
  {
    modelValue: '',
    error: ''
  }
)

const emit = defineEmits(['update:modelValue'])

const emitUpdate = (val: string) => {
  emit('update:modelValue', val)
}

const parameters = ref([])

const getParameter = (editor: any, params: any) => {
  const itemsMenu = []
  for (const param of params) {
    if (param.children?.length === 0) {
      itemsMenu.push({
        type: 'menuitem',
        text: param.tag,
        onAction: function () {
          editor.insertContent(param.name)
        }
      })
    } else {
      itemsMenu.push({
        type: 'nestedmenuitem',
        text: param.tag,
        getSubmenuItems: function () {
          const itemsSubMenu: any = []
          param.children.reduce((res: any, value: any) => {
            if (!res[value.tag]) {
              res[value.tag] = value
              itemsSubMenu.push({
                type: 'menuitem',
                text: value.tag,
                onAction: function () {
                  editor.insertContent(value.name)
                }
              })
            }
            return res
          }, [])
          return itemsSubMenu
        }
      })
    }
  }
  return itemsMenu
}

const configEditor = ref({
  highlight_on_focus: true,
  menubar: false,
  height: '100%',
  plugins:
    'searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars',
  toolbar:
    'mybutton | undo redo | blocks bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview | insertfile image ',
  setup: function (editor: any) {
    /* example, adding a toolbar menu button */
    editor.ui.registry.addMenuButton('mybutton', {
      text: 'Parametros',
      fetch: function (callback: any) {
        const items = getParameter(editor, parameters.value)
        callback(items)
      }
    })
  },
  quickbars_insert_toolbar: 'quicktable image',
  quickbars_selection_toolbar:
    'visualchars blocks | bold italic underline | formatselect | blockquote quicklink',
  contextmenu: 'undo redo | inserttable | cell row column deletetable '
})

onMounted(async () => {
  parameters.value = await getParamsTemplate()
})
</script>

<template>
  <div
    class="w-full h-full z-10 border rounded-xl"
    :class="[error ? 'border-red-500' : 'border-gray-300']">
    <Editor
      :model-value="modelValue"
      @update:modelValue="emitUpdate"
      api-key="c43dsljutm4pp50kpk4a5c9ot08uj7tmokxwh74158kqr0gs"
      :init="configEditor" />
    <span v-if="error" class="text-xs text-red-500 w-full flex justify-end">
      {{ error }}
    </span>
  </div>
</template>
